export default "__VITE_ASSET__DtSm8VX7__"